module.exports = __webpack_public_path__ + "img/fresh_grass.eba3f5cf.jpg";